/* eslint-disable hubspot-dev/no-unsafe-i18n-at-module-eval */
/* eslint-disable hubspot-dev/no-private-classes */

import { getTranslationOrInnerText, getElementId } from 'whisper-base';
export function getButtonProperties(element) {
  if (!(element instanceof HTMLButtonElement)) {
    return null;
  }
  const button = element;
  const variant = button.classList.contains('private-button--primary') ? 'primary' : button.classList.contains('private-button--secondary') ? 'secondary' : button.classList.contains('private-button--tertiary') ? 'tertiary' : 'other';
  const i18nElement = button && button.querySelector('i18n-string[data-key]');
  const locale = i18nElement && i18nElement.dataset.localeAtRender ? i18nElement.dataset.localeAtRender : 'unknown';
  return {
    type: 'button',
    id: getElementId(button),
    text: getTranslationOrInnerText(button),
    variant,
    locale
  };
}